import api from "@/services/api";

const state = {
  list: [],
};

const mutations = {
  SET_QUOTATIONS(state, quotations) {
    state.list = quotations;
  },
};

const actions = {
  // ================= CREATE =================
  async createQuotation(_, payload) {
    try {
      const res = await api.post("/quotations", payload);
      return res.data;
    } catch (error) {
      console.error("Error creating quotation:", error.message);
      throw error;
    }
  },

  // ================= GET ALL =================
  async getQuotations({ commit }) {
    try {
      const res = await api.get("/quotations");
      commit("SET_QUOTATIONS", res.data);
    } catch (error) {
      console.error("Error fetching quotations:", error.message);
      throw error;
    }
  },

  // ================= GET BY ID =================
  async getQuotationById(_, id) {
    try {
      const res = await api.get(`/quotations/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  // ================= UPDATE =================
  async updateQuotation(_, payload) {
    try {
      const id = payload.id;
      const res = await api.put(`/quotations/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("Error updating quotation:", error.message);
      throw error;
    }
  },

  // ================= DELETE =================
  async deleteQuotation(_, id) {
    try {
      const res = await api.delete(`/quotations/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting quotation:", error.message);
      throw error;
    }
  },

  // ================= NEXT NUMBER =================
  async getNextQuotationNumber() {
    try {
      const res = await api.get("/quotations/next-quotation-number");
      return res.data.nextQuotationNumber;
    } catch (error) {
      console.error("Error fetching next quotation number:", error.message);
      throw error;
    }
  },

  // ================= CONVERT TO INVOICE =================
  async convertToInvoice(_, { id, payload }) {
    try {
      const res = await api.post(`/quotations/${id}/convert-to-invoice`, payload);
      return res.data;
    } catch (error) {
      console.error("Error converting quotation to invoice:", error.message);
      throw error;
    }
  },

  // ================= DOWNLOAD FILE =================
  async downloadQuotationFile(_, fileKey) {
    try {
      const res = await api.get(`/quotations/download/${encodeURIComponent(fileKey)}`, {
        responseType: "blob",
      });
      return res;
    } catch (error) {
      console.error("Error downloading quotation file:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
